

import React from 'react';
import { ArgumentsTable } from '../components/ArgumentsTable';
import ServiceForm from '../components/ServiceForm';


const serviceEndpoint = "season/%sid/generic-event/new";
const serviceArguments = [
  { name: 'title',     type: 'string',  mandatory: true, default: null, description: 'Title of the event'},
  { name: 'date',     type: 'date',  mandatory: true, default: null, description: 'Training session date using format yyyy-mm-dd hh:ii:ss'},
  { name: 'description', type: 'string',  mandatory: false, default: null, description: 'Description of the event'},
  { name: 'players', type: 'array of player ids',  mandatory: false, default: null, description: 'Set the training session players'}
];

const serviceUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
];

const serviceSample = {
  'title'       : 'Medical test',
  'date'        : '2020-10-25 10:30:00',
  'description' : 'Medical test for the whole team with a doctor of the federation',
  'players'     : [1,2,3,4,5]
}


export function GenericEventCreate() {
  return <GenericEventCreateComponent/>;
}


class GenericEventCreateComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>Create a new Generic Event</h3>

                  <p>Endpoint: <b>{serviceEndpoint}</b></p>

                  <p>
                    This service can be used to create a Generic Event.<br/>
                    Players can be an empty array. It should contain a list of player ids.<br/>
                    See the service <i>Players</i> to get the list of players.
                    <br/>
                  </p>
                  
                  <ServiceForm
                        args={serviceArguments}
                        urlArgs={serviceUrlArguments}
                        sample={serviceSample}
                        endpoint={serviceEndpoint}
                        authRequired={true}
                        usePayload={true}
                  />

                  <h4>Request</h4>
                  <p>
                    A JSON with the match data
                  </p>
                  <ArgumentsTable args={serviceArguments} />
                  
                  <h4>Response</h4>
                  <p>
                    The created Generic Event as JSON
                  </p>
                  
            </div>
        );
  }


} 